import React from 'react';

const Gender = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_74)">
            <g clipPath="url(#clip1_4217_74)">
                <path
                    d="M20 20V19.25C20 18.1228 19.5522 17.0418 18.7552 16.2448C17.9582 15.4478 16.8772 15 15.75 15H8.25C7.12283 15 6.04183 15.4478 5.2448 16.2448C4.44777 17.0418 4 18.1228 4 19.25V20"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4217_74">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4217_74">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Gender;
